module.exports = __webpack_public_path__ + "img/bnr2.e87237ba.png";